<template>
    <b-row>
        <b-col md="12">
            <component-header
                title="Notification Approval"
                :hasSearch="true"
                :hasReload="true"
                :isLoading="loading"
                @reload-data="refreshAllDataItem"
                @search-query="(val) => (filter = val)"
                :hasCreate="false"
                :hasback="false"
            />
            <b-card class="card-wrap" border-variant="info">
                <b-row class="filters-row my-1">
                    <b-col md="4">
                        <b-form-group>
                            <label class="d-block filter-label">Time Period</label>
                            <eb-select
                                type="select"
                                v-model="selectedPeriod"
                                :options="periodList"
                                label="text"
                                :id="'selecttime'"
                                :selected="selectedPeriod"
                                @input="changePeriod"
                            ></eb-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group>
                            <label class="d-block filter-label">Status</label>
                            <eb-select
                                type="select"
                                v-model="selectedStatus"
                                :options="['PENDING', 'APPROVED', 'REJECTED']"
                                :id="'selectdealer'"
                                :selected="selectedStatus"
                                placeholder="Select Status"
                                @input="changeProvider"
                            ></eb-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group>
                            <label class="d-block filter-label">Notification Type</label>
                            <eb-select
                                type="select"
                                v-model="selectedNotification"
                                :options="[
                                    'Bulk Notification',
                                    'Bulk Promotion',
                                ]"
                                :id="'selectnotetype'"
                                :selected="selectedNotification"
                                placeholder="Select Notification Type"
                            ></eb-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <div class="table-wrapper">
                    <b-table
                        :dark="dark"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive="sm"
                        class="mt-3 tableRadius approval-table"
                        :items="approvalNotificationList"
                        :fields="tableFields"
                        :per-page="perPage"
                        :filter="filter"
                        @filtered="onFilter"
                        thead-class="header"
                        show-empty
                        :busy="loading"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(action)" slot-scope="data">
                            <div class="d-flex">
                                <div>
                                    <b-button
                                        size="sm"
                                        class="button-circle"
                                        variant="primary"
                                        @click="
                                            viewApprovalNotification(data.item)
                                        "
                                    >
                                        <i class="fa fa-eye"></i>
                                    </b-button>
                                </div>
                            </div>
                        </template>
                    </b-table>
                </div>
                <div class="pagination-wrapper">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="filterCount"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        @change="paginationClick"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import ebSelect from "@/components/FormElements/Select.vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
export default {
    name: "approvalNotification",
    components: {
        ebButton,
        ebSelect,
        ComponentHeader,
    },
    data() {
        return {
            filterCount: 100,
            loading: false,
            perPage: 10,
            currentPage: 1,
            filter: "",
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            dark: false,
            context: "Add",
            sortBy: "createdAt",
            sortDesc: true,
            tableFields: [
                {
                    key: "template.name",
                    label: "Template Name",
                },
                {
                    key: "category",
                    label: "Template Category",
                },
                {
                    key: "template._id",
                    label: "Template Id",
                },
                {
                    key: "template.concern",
                    label: "Concern",
                },
                {
                    key: "template.amount",
                    label: "Amount",
                },
                {
                    key: "scheduleDate",
                    label: "Schedule Time",
                    formatter: "formateScheduleDate",
                    sortable: true,
                },
                {
                    key: "status",
                    formatter: "criteriaStatus",
                    tdClass: (value) => {
                        if (value === "APPROVED") {
                            return "status-green";
                        } else if (value === "PENDING") {
                            return "status-orange";
                        } else {
                            return "status-red";
                        }
                    },
                },
                {
                    key: "action",
                },
            ],
            periodList: [
                {
                    text: "Last 7 days",
                    value: 7,
                },
                {
                    text: "Last 15 days",
                    value: 15,
                },
                {
                    text: "Last 30 days",
                    value: 30,
                },
                {
                    text: "Last 3 Months",
                    value: 90,
                },
                {
                    text: "Last 6 Months",
                    value: 180,
                },
            ],
            selectedPeriod: {
                text: "Last 7 days",
                value: 7,
            },
            selectedStatus: "",
            selectedNotification: "",
        };
    },
    computed: {
        ...mapGetters({
            GetFetchBulkNotificationList:
                "approvalNotificationBulk/GetFetchBulkNotificationList",
        }),
        approvalNotificationList() {
            if (this.selectedNotification == "Bulk Notification") {
                let list = this.GetFetchBulkNotificationList.filter(
                    (notificationList) => {
                        if (notificationList.category == "NOTIFICATION") {
                            return notificationList;
                        }
                    },
                );
                return list;
            } else if (this.selectedNotification == "Bulk Promotion") {
                let list = this.GetFetchBulkNotificationList.filter(
                    (notificationList) => {
                        if (notificationList.category == "PROMO") {
                            return notificationList;
                        }
                    },
                );
                return list;
            } else return this.GetFetchBulkNotificationList;
        },
    },
    methods: {
        async getApprovalsNotificatinList() {
            this.loading = true;
            let payload = {
                limit: 10,
                page: this.currentPage,
                fromDate: moment()
                    .subtract(this.selectedPeriod.value, "days")
                    .format("YYYY-MM-DD"),
                toDate: moment().format("YYYY-MM-DD"),
                status: this.selectedStatus,
            };
            await this.$store
                .dispatch(
                    "approvalNotificationBulk/fetchBulkNotificationList",
                    payload,
                )
                .then((res) => {
                    this.filterCount = res.meta.total > 0 ? res.meta.total : 1;
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        async paginationClick(e) {
            this.currentPage = e;
            await this.getApprovalsNotificatinList();
        },
        changePeriod(event) {
            this.selectedPeriod = event;
            this.currentPage = 1;
            // this.filterCount = 1;
            this.getApprovalsNotificatinList();
        },
        changeProvider() {
            this.currentPage = 1;
            // this.filterCount = 1;
            this.getApprovalsNotificatinList();
        },

        async viewApprovalNotification(data) {
            this.$router.push({
                name: "ApprovalNotificationDetails",
                params: { id: data._id },
            });
        },

        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        criteriaStatus(value) {
            const capitalized =
                value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
            return capitalized;
        },
        formateScheduleDate(value) {
            return moment(String(value)).format("DD/MM/YYYY hh:mm A");
        },
        refreshAllDataItem() {
            this.loading = true;
            (this.selectedPeriod = {
                text: "Last 7 days",
                value: 7,
            }),
                (this.selectedNotification = "");
            let payload = {
                limit: 10,
                page: this.currentPage,
                fromDate: moment()
                    .subtract(this.selectedPeriod.value, "days")
                    .format("YYYY-MM-DD"),
                toDate: moment().format("YYYY-MM-DD"),
                status: "",
                
            };
            (this.selectedStatus = ""),
                this.$store
                    .dispatch(
                        "approvalNotificationBulk/fetchBulkNotificationList",
                        payload,
                    )
                    .then((res) => {
                        this.filterCount =
                            res.meta.total > 0 ? res.meta.total : 1;
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
        },
    },
    mounted() {
        this.refreshAllDataItem();
    },
};
</script>
<style scoped>
.status-orange {
    color: #ff9f47;
    font-weight: 600;
}

.status-green {
    color: #017efa;
    font-weight: 600;
}
.status-red {
    color: #ff1a1a;
    font-weight: 600;
}

.filters-row {
    align-items: flex-end;
}

.filter-label {
    font-weight: 600;
    margin-bottom: 0.25rem;
}

.table-wrapper {
    overflow-x: auto;
    width: 100%;
}

.approval-table {
    border-radius: 12px;
}

.pagination-wrapper {
    float: right;
    margin-top: 1rem;
}

@media (max-width: 991.98px) {
    .filters-row {
        align-items: flex-start;
    }
}

@media (max-width: 767.98px) {
    .pagination-wrapper {
        float: none;
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 1rem;
    }

    .table-wrapper {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .filter-label {
        font-size: 0.9rem;
    }
}

@media (max-width: 575.98px) {
    .filter-label {
        font-size: 0.85rem;
    }
}
</style>
